import React from "react";
import PropTypes from "prop-types";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField/TextField";

const StepDescription = props => {
    const {formik} = props;

    return (
        <React.Fragment>
            <Typography variant="h6">
                Testi in italiano
            </Typography>

            <Box sx={{my: 4}}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <TextField label="Titolo (in italiano)"
                                   fullWidth
                                   id="titleIt"
                                   value={formik.values.titleIt}
                                   onChange={formik.handleChange}
                                   error={formik.touched.titleIt && Boolean(formik.errors.titleIt)}
                                   helperText={formik.touched.titleIt && formik.errors.titleIt}/>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField label="Descrizione (in italiano)"
                                   multiline
                                   minRows={4}
                                   fullWidth
                                   id="descriptionIt"
                                   value={formik.values.descriptionIt}
                                   onChange={formik.handleChange}
                                   error={formik.touched.descriptionIt && Boolean(formik.errors.descriptionIt)}
                                   helperText={formik.touched.descriptionIt && formik.errors.descriptionIt}/>
                    </Grid>
                </Grid>
            </Box>

            <Typography variant="h6">
                Testi in inglese
            </Typography>

            <Box sx={{my: 4}}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <TextField label="Titolo (in inglese)"
                                   fullWidth
                                   id="titleEn"
                                   value={formik.values.titleEn}
                                   onChange={formik.handleChange}
                                   error={formik.touched.titleEn && Boolean(formik.errors.titleEn)}
                                   helperText={formik.touched.titleEn && formik.errors.titleEn}/>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField label="Descrizione (in inglese)"
                                   multiline
                                   minRows={4}
                                   fullWidth
                                   id="descriptionEn"
                                   value={formik.values.descriptionEn}
                                   onChange={formik.handleChange}
                                   error={formik.touched.descriptionEn && Boolean(formik.errors.descriptionEn)}
                                   helperText={formik.touched.descriptionEn && formik.errors.descriptionEn}/>
                    </Grid>
                </Grid>
            </Box>
        </React.Fragment>
    )
};

PropTypes.StepDescription = {
    formik: PropTypes.object.isRequired
};

export default StepDescription;